<div class="payment-form-modal-container" [style]="modalCssVars">
    <div class="payment-form-content form-root" [class]="rootCssClasses" [style]="rootCssVars">
        <form>
            <button type="button" class="close-modal-btn" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>

            @if (isProductTypeEduCourse) {
                <div class="sp-ui-text payment-form-description">
                    <h2 class="payment-modal-title">
                        {{ widget.data.paymentFormName }}
                    </h2>
                </div>
            } @else {
                <div class="sp-ui-text payment-form-description">
                    <h2 class="payment-modal-title">
                        {{ widget.data.paymentFormName }}
                    </h2>
                    <p class="payment-modal-product-name">
                        {{ widget.data.productName }}
                    </p>
                    @if (!paymentElement.isEditableTotalCost) {
                        <p class="payment-modal-product-price">
                            {{ paymentElement.amount }} {{ paymentElement.currency }}
                        </p>
                    }
                </div>

                @if (paymentElement.isEditableTotalCost) {
                    <div class="min-amount-control form-field">
                        <label>{{ "amount" | translate }}</label>
                        <div class="input-group">
                            <input
                                style="pointer-events: none"
                                type="number"
                                [value]="paymentElement.amount"
                                class="form-control"
                                [class]="fieldCssClasses"
                            />

                            <div class="input-group-addon">
                                {{ paymentElement.currency }}
                            </div>
                        </div>

                        <div class="sp-ui-text">
                            <p>
                                <small>{{
                                    "minimal_amount"
                                        | translate: { PRICE: paymentElement.amount, CURRENCY: paymentElement.currency }
                                }}</small>
                            </p>
                        </div>
                    </div>
                }

                <span class="modal-divider"></span>
            }

            @for (control of elements; track control) {
                @if (control.type !== formInputType.hidden) {
                    <div class="form-field" style="pointer-events: none">
                        @switch (true) {
                            @case (typeGuards.isInput(control)) {
                                @if (inputSettings.showLabels) {
                                    <label> {{ control.label }}{{ control.required ? " *" : "" }} </label>
                                }
                                @if (!control.isDynamicPlaceholderEnabled) {
                                    <input
                                        class="form-control"
                                        [class]="fieldCssClasses"
                                        [attr.type]="control.htmlInputType"
                                        [attr.placeholder]="control.placeholder"
                                    />
                                }
                                @if (control.type === "phone" && control.isDynamicPlaceholderEnabled) {
                                    <ngx-intl-tel-input
                                        [cssClass]="'form-control ' + fieldCssClasses"
                                        [enableAutoCountrySelect]="true"
                                        [selectFirstCountry]="false"
                                        [separateDialCode]="true"
                                        [enablePlaceholder]="true"
                                        [searchCountryFlag]="true"
                                        [phoneValidation]="true"
                                        [searchCountryField]="[SearchCountryField.All]"
                                        [excludeCountries]="excludeCountries"
                                        [selectedCountryISO]="CountryISO"
                                        [numberFormat]="PhoneNumberFormat.International"
                                    />
                                }
                            }

                            @case (typeGuards.isTextarea(control)) {
                                @if (inputSettings.showLabels) {
                                    <label> {{ control.label }}{{ control.required ? " *" : "" }} </label>
                                }
                                <textarea
                                    class="form-control-textarea"
                                    [class]="fieldCssClasses"
                                    [attr.placeholder]="control.placeholder"
                                ></textarea>
                            }

                            @case (typeGuards.isCheckbox(control)) {
                                <label class="sp-checkbox">
                                    <input [attr.type]="control.htmlInputType" />
                                    @if (control.required) {
                                        <span
                                            class="checkbox-text"
                                            [innerHTML]="' ' + (control.label | removePTags) + ' *'"
                                        ></span>
                                    } @else {
                                        <span
                                            class="checkbox-text"
                                            [innerHTML]="' ' + (control.label | removePTags)"
                                        ></span>
                                    }
                                </label>
                            }

                            @case (typeGuards.isRadio(control)) {
                                @if (inputSettings.showLabels) {
                                    <label> {{ control.label }}{{ control.required ? " *" : "" }} </label>
                                }
                                @for (option of control.options; track option) {
                                    <div class="radio-options">
                                        <label>
                                            <input
                                                [attr.type]="control.htmlInputType"
                                                [value]="option.value"
                                                [checked]="option.selected"
                                            />
                                            <span class="radio-text"> {{ option.label }}</span>
                                        </label>
                                    </div>
                                }
                            }

                            @case (typeGuards.isSelect(control)) {
                                @if (inputSettings.showLabels) {
                                    <label> {{ control.label }}{{ control.required ? " *" : "" }} </label>
                                }
                                <select class="form-control" [class]="fieldCssClasses">
                                    <option [ngValue]="null" [selected]="getSelected(control.options)" disabled>
                                        {{ "select_value" | translate }}
                                    </option>
                                    @for (option of control.options; track option) {
                                        <option [value]="option.value" [selected]="option.selected">
                                            {{ option.label }}
                                        </option>
                                    }
                                </select>
                            }
                        }
                    </div>
                }
            }

            @if (activePaymentElements.length > 1) {
                <div class="form-field" style="pointer-events: none">
                    @if (inputSettings.showLabels) {
                        <label>{{ "payment_method" | translate }}</label>
                    }
                    <select class="form-control" [class]="fieldCssClasses">
                        @for (paymentElement of activePaymentElements; track paymentElement) {
                            <option>
                                {{ getPaymentElementLabel(paymentElement.type) | translate }}
                            </option>
                        }
                    </select>
                </div>
            }

            @if (isProductTypeEduCourse) {
                <span class="modal-divider"></span>
                <div class="sp-ui-text payment-form-description">
                    <p class="payment-modal-product-name">
                        {{ widget.data.productName }}
                    </p>

                    @if (!paymentElement?.isEditableTotalCost) {
                        <p class="payment-modal-product-price">
                            {{ paymentElement?.amount }} {{ paymentElement?.currency }}
                        </p>
                    }
                </div>
            }

            <div class="form-button-wrapper form-vertical" [style]="buttonCssVars">
                <a [class]="getButtonStyles(formButtonSettings)">
                    @if (formButtonSettings.buttonIcon?.isActive) {
                        <span class="icon" [innerHTML]="getIcon(formButtonSettings.buttonIcon?.icon)"></span>
                    }
                    {{ formButtonSettings.label }}
                </a>
            </div>

            @if (!!widget.data.modalTextHint) {
                <div class="modal-hint-text" [innerHtml]="widget.data.modalTextHint | spSafeHtml"></div>
            }
        </form>
    </div>
</div>
